module.exports = __webpack_public_path__ + "img/sel_Chengdu.c6338fda.jpg";